<template>
    <div class="forum-container">
        <nav-header></nav-header>
        <div class="forun-main" v-if="details">
            <div class="forum-header">
                <div class="content-main">
                    <div class="main-flex">
                        <div class="head-left">
                            <img class="img-title" src="@/assets/activity/forum/gyfwwlfzlt.png" alt="工业服务未来发展论坛">
                            <p>{{details.LiveTimeRange}}</p>
                        </div>
                        <div class="head-right">
                            <div class="share-bg">
                                <div class="tips-div" style="position: relative">
                                    <div style="overflow: hidden;">
                                        <h5 class="subscribe" :class="{'lottery':details.IsPublishAwards}"></h5>
                                    </div>
                                    <p class="n">{{details.SharedCount}}人已预约</p>
                                    <div class="popover-tips">直播当天开奖，中奖锦鲤可获得万元现金、电动牙刷、署名白皮书等锦鲤大礼包。</div>
                                </div>
                                <div>
                                    <!-- 预约跟未开奖前显示 -->
                                    <template v-if="!details.IsPublishAwards">
                                        <div class="label-box">
                                            <label for="">电子版白皮书</label>
                                            <label for="">万元现金锦鲤</label>
                                            <label for="">等好礼</label>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <!-- 开奖但未中奖 -->
                                        <div class="label-box label-tips-no" v-if="!details.IsWinAwards">
                                            <label for="">很抱歉，您</label>
                                            <label for="">未中奖</label>
                                            <p class="min-top">锦鲤号码：{{details.WinAwardsLotteryYards}}</p>
                                        </div>
                                        <!-- 开奖中奖 -->
                                        <div class="label-box label-tips-no" v-else>
                                            <label for="">恭喜您已中奖</label>
                                            <p class="min-top">请联系速派客服</p>
                                            <p>领取大奖</p>
                                        </div>
                                    </template>
                                </div>
                                <template v-if="!details.IsPublishAwards">
                                    <p class="lucky-n link" v-if="!details.IsSubscribe" @click="shareShow">分享预约<i class="el-icon-caret-right"></i></p>
                                    <p class="lucky-n" v-else>幸运号码：{{details.LotteryYards || '无'}}</p>
                                </template>
                                <template v-else>
                                    <p class="lucky-n">幸运号码：{{details.LotteryYards || '无'}}</p>
                                </template>
                            </div>
                            <button class="download-btn" v-if="details.IsSubscribe" @click="downloadFun">下载白皮书</button>
                        </div>
                    </div>
                    <div class="video-chat-main">
                        <div class="video-box">
                            <!-- $refs.videoPlayer.player.pause() -->
                            <!-- $refs.videoPlayer.player.play() -->
                            <video-player  class="video-player vjs-custom-skin"
                                ref="videoPlayer"
                                :playsinline="true"
                                :options="videoPlayerOptions"
                                @play="onPlayerPlay($event)"
                                @pause="onPlayerPause($event)"
                                @ended="onPlayerEnded($event)"
                                @waiting="onPlayerWaiting($event)"
                                @playing="onPlayerPlaying($event)"
                                @loadeddata="onPlayerLoadeddata($event)"
                                @timeupdate="onPlayerTimeupdate($event)"
                                @canplay="onPlayerCanplay($event)"
                                @canplaythrough="onPlayerCanplaythrough($event)"
                                @statechanged="playerStateChanged($event)"
                                @ready="playerReadied"
                            ></video-player>
                        </div>
                        <div class="chat-box">
                            <div class="up-scroll" id="up">
                                <ul class="chat-list">
                                    <li v-for="(item,index) in chatArr" :key="index">
                                        <img v-show="item.isBpoMember" src="@/assets/activity/forum/vip.png" alt="VIP">
                                        {{item.userName}}：{{item.message}}
                                    </li>
                                </ul>
                            </div>
                            <div class="send-box">
                                <input type="text" placeholder="参与讨论" v-model="text" ref="inputText" @keyup.enter="sendButton">
                                <button @click="sendButton">发送</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="forum-content">
                <div class="content-main">
                    <div>
                        <div class="column-title">
                            <img src="@/assets/activity/forum/jchd.png" alt="精彩互动" />
                        </div>
                        <div class="subnav-box">
                            <button :class="{'on':status == 1}" @click="status = 1;">速派论坛</button>
                            <button :class="{'on':status == 2}" @click="status = 2;">朋友圈</button>
                            <button :class="{'on':status == 3}" @click="status = 3">微博</button>
                            <button :class="{'on':status == 4}" @click="status = 4">公众号</button>
                            <button :class="{'on':status == 5}" @click="status = 5">抖音</button>
                            <button :class="{'on':status == 6}" @click="status = 6">快手</button>
                            <button :class="{'on':status == 7}" @click="status = 7">知乎</button>
                        </div>
                        <div class="container-list">
                            <div class="int-item" v-show="status == 1">
                                <div class="item-left">
                                    <ul class="bbs-list">
                                        <li class="bbs-item" v-for="(item,index) in forumList" :key="index" @click="toDetail(item)">
                                            <div>
                                                <h3>{{item.Title}}</h3>
                                                <span class="icon-no-praise" :class="{'icon-yes-praise':item.IsThumbUp}">{{item.ThumbUpCount}}</span>
                                            </div>
                                            <p>{{item.ShortContent}}</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="item-right">
                                    <p>在速派论坛中正文带   #工业服务未来发展论坛#  发帖<br/>点赞前十的帖子将获得：</p>
                                    <ol>
                                        <li class="xz">工业服务行业未来论坛特别贡献实名勋章</li>
                                        <li class="ts">精装版《工业服务行业白皮书》实名感恩特别定制版实体书</li>
                                    </ol>
                                    <button @click="$router.push({path:'/newsList'})">去速派论坛</button>
                                </div>
                            </div>
                            <div class="int-item" v-show="status == 2">
                                <div class="item-left">
                                    <div class="share-status">
                                        <img src="@/assets/activity/forum/pyq.png" alt="朋友圈">
                                    </div>
                                </div>
                                <div class="item-right">
                                    <p>按格式转发本站至朋友圈并配文您的抽奖号码<br/>若直播开奖时中奖，可凭朋友圈截图领取</p>
                                    <ol>
                                        <li class="lw">奖品或红包</li>
                                    </ol>
                                    <button @click="showShare = true">去朋友圈</button>
                                </div>
                            </div>
                            <div class="int-item" v-show="status == 3">
                                <div class="item-left">
                                    <div class="share-status">
                                        <img src="@/assets/activity/forum/wb.png" alt="微博">
                                    </div>
                                </div>
                                <div class="item-right">
                                    <p>发表话题为#工业服务未来论坛#或者#工业服务行业白皮<br/>书#的任意微博，点赞排名在微博同话题下排名前3，可<br/>获得</p>
                                    <ol>
                                        <li class="ts">精装版《工业服务行业白皮书》实名感恩特别定制版实体书</li>
                                    </ol>
                                    <a href="https://weibo.com/" target="_blank">去微博</a>
                                </div>
                            </div>
                            <div class="int-item" v-show="status == 4">
                                <div class="item-left">
                                    <div class="share-status">
                                        <img src="@/assets/activity/forum/gzh.png" alt="公众号">
                                    </div>
                                </div>
                                <div class="item-right">
                                    <p>任意微信公众号发表一篇标题包含“工业服务未来论坛”<br/>或者“工业服务行业白皮书”的文章，若阅读数大于500<br/>该文小编可凭任意身份证明领取</p>
                                    <ol>
                                        <li class="ts">精装版《工业服务行业白皮书》实名感恩特别定制版实体书</li>
                                    </ol>
                                    <button @click="showShare = true">去公众号</button>
                                </div>
                            </div>
                            <div class="int-item" v-show="status == 5">
                                <div class="item-left">
                                    <div class="share-status">
                                        <img src="@/assets/activity/forum/gzh.png" alt="抖音">
                                    </div>
                                </div>
                                <div class="item-right">
                                    <p>发表话题为#工业服务未来论坛#或者#工业服务行业白皮<br/>书#的任意相关视频，点赞排名在抖音同话题下排名前3,<br/>可获得</p>
                                    <ol>
                                        <li class="ts">精装版《工业服务行业白皮书》实名感恩特别定制版实体书</li>
                                    </ol>
                                    <a href="https://www.douyin.com/" target="_blank">去抖音</a>
                                </div>
                            </div>
                            <div class="int-item" v-show="status == 6">
                                <div class="item-left">
                                    <div class="share-status">
                                        <img src="@/assets/activity/forum/ks.png" alt="快手">
                                    </div>
                                </div>
                                <div class="item-right">
                                    <p>发表话题为#工业服务未来论坛#或者#工业服务行业白皮<br/>书#的任意相关视频，点赞排名在抖音同话题下排名前3,<br/>可获得</p>
                                    <ol>
                                        <li class="ts">精装版《工业服务行业白皮书》实名感恩特别定制版实体书</li>
                                    </ol>
                                    <a href="https://www.kuaishou.com/" target="_blank">去快手</a>
                                </div>
                            </div>
                            <div class="int-item" v-show="status == 7">
                                <div class="item-left">
                                    <div class="share-status">
                                        <img src="@/assets/activity/forum/zh.png" alt="知乎">
                                    </div>
                                </div>
                                <div class="item-right">
                                    <p>发表一篇标题包含“工业服务未来论坛”或者“工业服务<br/>行业白皮书”的文章，若赞同数大于50，该文小编可凭任<br/>意身份证明领取</p>
                                    <ol>
                                        <li class="ts">精装版《工业服务行业白皮书》实名感恩特别定制版实体书</li>
                                    </ol>
                                    <a href="https://www.zhihu.com/" target="_blank">去知乎</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="column-title">
                            <img src="@/assets/activity/forum/dkgd.png" alt="大咖观点" />
                        </div>
                        <div class="ups-main">
                            <ul class="ups-list">
                                <li v-for="(item,index) in serviceVideoList" :key="index" @click="playVideo(item.VideoUrl)">
                                    <img :src="item.VideoCoverImgUrl" alt="">
                                    <span>{{item.VideoName}}</span>
                                </li>
                                <li @click="clickDialogShow(1)">
                                    <div>
                                        <p>征集更多观点</p>
                                        <button>点击联系>></button>
                                    </div>
                                </li>
                            </ul>
                            <ol class="pagination-list">
                                <li :class="{'on':index == idx}" v-for="index in tatal" :key="index" @click="getServiceList(index)">{{index}}</li>
                            </ol>
                        </div>
                    </div>
                    <div>
                        <div class="column-title">
                            <img src="@/assets/activity/forum/gxbrkdszhrz.png" alt="工信部认可的数字化认证" />
                        </div>
                        <div class="certification-main">
                            <div class="item-one" @click="showQr=true">
                                <h3>数字化工业服务工程师<br/>供配电低压类证书</h3>
                            </div>
                            <div class="item-two" @click="showQr=true">
                                <h3>供配电<br/>中高压类</h3>
                            </div>
                            <div class="item-three">
                                <div class="items" @click="showQr=true">
                                    <div>
                                        <h3>自动化类</h3>
                                        <p>PLC可编程逻辑控制器</p>
                                    </div>
                                </div>
                                <div class="items" @click="showQr=true">
                                    <div>
                                        <h3>自动化类</h3>
                                        <p>HIMI人机交互</p>
                                    </div>
                                </div>
                            </div>
                            <div class="item-three">
                                <div class="items" @click="showQr=true">
                                    <div>
                                        <h3>自动化类</h3>
                                        <p>数控机床系统</p>
                                    </div>
                                </div>
                                <div class="items" @click="showQr=true">
                                    <div>
                                        <h3>自动化类</h3>
                                        <p>DCS分布式控制系统</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="column-title">
                            <img src="@/assets/activity/forum/yqzz.png" alt="友情赞助" />
                        </div>
                        <div class="friendlink-main">
                            <ul class="friendlink-list">
                                <li class="items" v-for="(item,index) in sponsorList" :key="index" @click="linkSponsor(item.SponsorSiteUrl)">
                                    <div class="logo-tips">
                                        <img :src="item.LogoUrl" alt="">
                                        <p>{{item.SponsorIntroduce}}</p>
                                    </div>
                                    <h3>{{item.SponsorName}}</h3>
                                </li>
                                <li @click="clickDialogShow(2)">
                                    <div>
                                        <p>征集更多赞助商</p>
                                        <button>点击联系>></button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <my-dialog
            class="share-dialog"
            :show="showShare"
            title="分享"
            :titleCenter="true"
            @close="closeShare" 
            width="600px"
        >
            <div class="share-box">
                <div class="share-item">
                    <div class="logo-box">
                        <img src="@/assets/activity/forum/wxlogo.png" alt="微信" />
                        <p>分享到微信</p>
                    </div>
                    <div class="hover-er">
                        <i class="car el-icon-caret-top"></i>
                        <img src="" alt="二维码"/>
                        <p>请使用微信扫一扫</p>
                    </div>
                </div>
                <div class="share-item">
                    <a href="https://weibo.com/" target="_blank">
                        <div class="logo-box">
                            <img src="@/assets/activity/forum/wblogo.png" alt="微博" />
                            <p>分享到新浪微博</p>
                        </div>
                    </a>
                </div>
            </div>
        </my-dialog>
        <my-dialog 
            class="collect-dialog" 
            :show="showCollect" 
            :title="dialogTitle" 
            :titleCenter="true" 
            @close="closeDetails" 
            width="600px"
        >
            <div class="form form-collect" v-if="!successSmt">
                <div class="form-item">
                    <span class="label"><i class="required">*</i>您的姓名：</span>
                    <div class="input-box">
                        <input type="text" class="input" placeholder="姓名" v-model.trim="form.TrueName">
                    </div>
                </div>
                <div class="form-item">
                    <span class="label"><i class="required">*</i>您的联系方式：</span>
                    <div class="input-box">
                        <input type="text" class="input" placeholder="手机号" v-model.trim="form.HandSet">
                    </div>
                </div>
                <div class="form-item">
                    <span class="label"><i class="required">*</i>您的职称：</span>
                    <div class="input-box">
                        <input type="text" class="input" placeholder="职位名称" v-model.trim="form.Position">
                    </div>
                </div>
                <div class="form-item">
                    <span class="label"><i class="required">*</i>所在机构：</span>
                    <div class="input-box">
                        <input type="text" class="input" placeholder="公司名称" v-model.trim="form.Organization">
                    </div>
                </div>
                <div class="btn-primary" @click="submit">确定</div>
            </div>
            <div v-else class="successTips">
                <p>您已成功提交</p>
                <p>请耐心等候，速派专员会尽快联系您！</p>
            </div>
        </my-dialog>
        <div class="screen-video" v-if="showVideo">
            <i class="el-icon-close close-x" @click="showVideo=false;viceVideoUrl='';$refs.videoPlayer.player.play()"></i>
            <video controlslist="nodownload nofullscreen noremoteplayback" :disablePictureInPicture="true" loop controls autoplay>
                <source :src="viceVideoUrl" type="video/mp4"/>
            </video>
        </div>
        <div class="ecode-box" v-if="showQr">
            <i class="el-icon-close close-x" @click="showQr=false"></i>
            <div>
                <img src="" alt="二维码" />
            </div>
        </div>
    </div>
</template>
<script>
import NavHeader from '@/components/navHeader.vue'
import {videoPlayer} from 'vue-video-player'
import $ from "jquery"
import {mapState} from 'vuex'
import Dialog from "@/components/gkDialog.vue";
import valid from '@/scripts/validate.js'
import {
  GetForumSubscribeInfo,
  DoForumSubscribeCallBack, //点击分享预约
  GetForumPostList,         //获取列表
  ListServiceForumVideo,    //大咖视频观点
  GetSponsorList,           //赞助商列表
  AddServiceForumCollectInfo,   //提交

  AddServiceForumStatistics,    //添加统计数据
} from '@/scripts/api.js'
var connection;
var int = null;
export default {
    components:{
        NavHeader,
        videoPlayer,
        "my-dialog": Dialog
    },
    data(){
        return {
            status: 1,
            video:'',         //具体视频
            fileType: 'mp4', // 资源的类型
            videoUrl: '',	// 资源的路径地址
            posterUrl: '',  //封面地址
            n: '',          //播放第几个
            isn: true,      //是否第一次播放
            text: '',
            chatArr: [],
            details: null,      //用户详情
            forumList: [],      //速派论坛
            serviceVideoList:[],//大咖观点
            tatal: Number,
            idx: 1,
            sponsorList: [],    //赞助商列表


            showVideo: false,
            viceVideoUrl: '',

            showShare: false,
            showQr: false,


            dialogTitle: '提交大咖观点',
            showCollect: false,
            form:{
                TrueName: '',       //姓名
                HandSet: '',        //手机号
                Position: '',       //职位
                Organization: '',   //机构
                CollectInfoType: 0, //征集信息类型 1大咖2赞助
            },
            smtLoading: false,
            successSmt: false,
            
        }
    },
    created(){},
    computed: {
        ...mapState({
            userInfo:state=>state.userInfo,
        }),
        videoPlayerOptions () {
            const videoPlayerOptions = {
                // playbackRates: [0.75, 1.0, 1.25, 1.5,2.0], //播放速度
                autoplay: true, // 是否自动播放。
                // controls: true,
                muted: false, // 是否静音播放，默认情况下将会消除任何音频。
                loop: false, // 是否循环播放。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                // aspectRatio: '3:1', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 是否流体从而按比例缩放以适应其容器。
                // flash:{hls:{withCreadentials:false}},//可以播放rtmp视频
                // html5:{hls:{withCreadentials:false}},//可以播放m3u8视频
                sources: [
                {
                    type: 'video/' + this.fileType,
                    src: this.videoUrl // 视频url地址
                }],
                poster: this.posterUrl, // 封面地址
                width: '100%',
                notSupportedMessage: '此视频暂无法播放...', // 当无法播放时允许覆盖Video.js，显示的默认信息。
                controlBar: {
                    timeDivider: false,
                    durationDisplay: false,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true,
                    currentTimeDisplay: false,
                    progressControl: false,
                }
            }
            return videoPlayerOptions
        },
    },
    mounted(){
        var self = this
        this.addServiceForumStatisticsFun();
        this.loadData();
        this.getForumPostListFun();
        this.listServiceForumVideoFun(1);
        this.getSponsorListFun();
        // 生成随机游客的账号也是有区分本地环境和线上环境的
        var request = 'https://activityapi.insupai.com'
        // if(process.env.NODE_ENV == 'production') {
        //     request = `https://activityapi.insupai.com`
        // }else if(process.env.NODE_ENV == 'text'){
        //     request = `http://tactivityapi.insupai.com`
        // }else if(process.env.NODE_ENV == 'development'){
        //     request = `http://activityapi.gongkongbpo.qa`
        // }
        connection = new signalR.HubConnectionBuilder().withUrl(`${request}/chatHub`).build();
        //加载前3条消息
        connection.on("GetTop3Msg", function (json) {
            self.chatArr = json
        });
        //接收到消息后
        connection.on("ReceiveMessage", function (json) {
            self.chatArr.push(json)
            var scrollHeight = $('.chat-list').prop("scrollHeight");
            $('#up').animate({scrollTop:scrollHeight},600)
        });
        //展示错误信息
        connection.on("ShowError", function (msg) {
            console.log("ShowError:" + msg);
        });

        this.start();
        //长时间会断开，断开后重新链接
        connection.onclose(() => {
            console.log('断开后重新链接')
            this.start();
        });
        
        window.setInterval(()=>{
            setTimeout(this.getForumPostListFun(),0)
        },30000)
    },
    
    methods:{
        // 添加统计数据
        addServiceForumStatisticsFun(){
            let data = {}
            data.AppId = 1
            data.UserCode = this.userInfo?.UserCode??''
            AddServiceForumStatistics(data).then(res=>{
                console.log('统计')
            })
        },
        // 加载数据
        loadData(){
            let data = {}
            data.UserId = this.userInfo?.UserId??'',
            data.CompanyId = this.userInfo?.CompanyId??'',
            data.platform = 'pcweb'
            GetForumSubscribeInfo(data).then(res=> {
                this.details = res.Data
                this.$nextTick(()=> {
                    if(this.details.LiveStep == 1) {
                        this.n = this.details.PreheatingVideoCurrentSortNum - 1
                        this.videoUrl = this.details.PreheatingVideoList[this.n].VideoUrl
                    }else if(this.details.LiveStep == 2){
                        this.videoUrl = this.details.LiveStreamingVideoUrl
                    }
                    this.$refs.videoPlayer.player.src(this.videoUrl)
                    if(this.details.LiveStep == 1) {
                        int = setInterval(()=>{
                            setTimeout(()=>{
                                let myDate = Date.parse(new Date())
                                let begin = new Date(this.details.LiveStartTime).getTime()
                                let end = new Date(this.details.LiveEndTime).getTime()
                                if(begin < myDate && myDate < end) {
                                    clearInterval(int)
                                    this.loadData();
                                }
                            },0)
                        },60000)
                    }
                })
            })
        },
        // 获取速派论坛
        getForumPostListFun(){
            let data = {}
            data.UserCode = this.userInfo?.UserCode??''
            GetForumPostList(data).then(res=>{
                this.forumList = res.Data.ForumPostModelList || []
            })
        },
        //打开详情
        toDetail(item){
            this.$router.push({
                path:'/newsDetail',
                query:{
                    id:item.Id
                }
            })
        },
        // 大咖视频观点列表
        listServiceForumVideoFun(idx){
            let data = {}
            data.PageIndex = idx;
            data.PageSize = 7;
            data.VideoType = 2;
            ListServiceForumVideo(data).then(res=>{
                this.tatal = Number(res.Data.TotalPages)
                this.serviceVideoList = res.Data.List || []
            })
        },
        getServiceList(i){
            this.idx = i
            this.listServiceForumVideoFun(i)
        },
        // 赞助商列表
        getSponsorListFun(){
            let data = {}
            data.PageNum = 0;
            data.PageSize = 1;
            GetSponsorList(data).then(res=>{
                this.sponsorList = res.Data.SponsorList || []
            })
        },
        // 打开分享
        shareShow(){
            if(!this.userInfo){
                this.$router.push('/companyLogin');
                return;
            }
            this.showShare = true
        },
        // 关闭分享
        closeShare(){
            let data = {}
            if(this.details.IsSubscribe) {
                this.showShare = false
                return
            }
            data.UserId = this.userInfo?.UserId??'',
            data.CompanyId = this.userInfo?.CompanyId??'',
            data.platform = 'pcweb'
            DoForumSubscribeCallBack(data).then(res=> {
                this.showShare = false
                this.loadData();
            })
        },
        // 下载白皮书
        downloadFun(){
            let url = this.details.DownLoadUrl
            // window.location.href = url
            window.open(this.details.DownLoadUrl)
        },
        // 全屏播放video
        playVideo(url){
            this.showVideo = true
            this.$refs.videoPlayer.player.pause()
            this.viceVideoUrl = url
        },
        
        // 打开弹框征集
        clickDialogShow(type){
            this.showCollect = true
            this.successSmt = false
            this.form.CollectInfoType = type
            if(type==1) {
                this.dialogTitle = '提交大咖观点'
            }else{
                this.dialogTitle = '征集赞助商'
            }
        },
        submit(){
            if(this.smtLoading) return
            if(!this.form.TrueName) {
                return this.$toast('请输入您的姓名');
            }
            if(!this.form.HandSet){
                return this.$toast('请输入您的手机号');
            }
            if(!valid.phone(this.form.HandSet) && this.form.HandSet!=''){
                return this.$toast('手机号格式不正确');
            }
            if(!this.form.Position) {
                return this.$toast('请输入您的职位名称');
            }
            if(!this.form.Organization) {
                return this.$toast('请输入您的公司名称');
            }
            let data = {
                ...this.form
            }
            this.smtLoading = true
            AddServiceForumCollectInfo(data).then(res => {
                this.smtLoading = false
                if(res.Result !=1) {
                    return this.$toast(res.Message);
                }
                this.successSmt = true
                this.form = {
                    TrueName: '',       //姓名
                    HandSet: '',        //手机号
                    Position: '',       //职位
                    Organization: '',   //机构
                    CollectInfoType: 0, //征集信息类型 1大咖2赞助
                }
            })

        },
        // 关闭弹框
        closeDetails(){
            if(this.smtLoading) return
            this.showCollect = false
            this.form = {
                TrueName: '',       //姓名
                HandSet: '',        //手机号
                Position: '',       //职位
                Organization: '',   //机构
                CollectInfoType: 0, //征集信息类型 1大咖2赞助
            }
        },
        // 连接
        start(){
            let self = this
            try {
                //链接
                connection.start().then(function () {
                    // console.log('connection.start');
                    let user = self.userInfo?.UserCode|| 0
                    //上线
                    connection.invoke("OnLine", user).catch(function (err) {
                        return console.error(err.toString());
                    });
                });
            }
            catch (err) {
                setTimeout(function () { this.start() }, 5000);
                return console.error(err);
            }
        },
        //发送消息
        sendButton(event){
            let self = this
            if(!self.userInfo){
                self.$router.push('/companyLogin');
                return;
            }
            if(!self.text) {
                self.$toast('内容不可为空！')
                self.$refs.inputText.focus()
                return
            }
            connection.invoke("SendMessage", this.text).then(res=>{
                self.text = ''
                self.$refs.inputText.focus()
            }).catch(function (err) {
                self.$toast('发送失败，请重试！')
                self.start();
                return
            });
            event.preventDefault();
        },
        // 播放回调
        onPlayerPlay(player) {
            // console.log('player play!', player)
        },
        // 暂停回调
        onPlayerPause(player) {
            // console.log('player pause!', player)
        },
        // 视频播完回调
        onPlayerEnded(player) {
            if(this.details.LiveStep == 1) {
                let myDate = Date.parse(new Date())
                let begin = new Date(this.details.LiveStartTime).getTime()
                let end = new Date(this.details.LiveEndTime).getTime()
                if(begin < myDate && myDate < end) {
                    return this.loadData();
                }
                if(this.n >= this.details.PreheatingVideoList.length-1) {
                    this.n = 0
                }else{
                    this.n ++
                }
                this.videoUrl = this.details.PreheatingVideoList[this.n].VideoUrl
                this.$refs.videoPlayer.player.src(this.videoUrl)
            }else if(this.details.LiveStep == 2) {
                return this.loadData();
            }
            // console.log('视频播完回调',player)
        },
        // DOM元素上的readyState更改导致播放停止
        onPlayerWaiting($event) {
            //console.log(player)
        },
        // 已开始播放回调
        onPlayerPlaying($event) {
            if(this.details.LiveStep == 1) {
                let myDate = Date.parse(new Date())
                let begin = new Date(this.details.LiveStartTime).getTime()
                let end = new Date(this.details.LiveEndTime).getTime()
                if(begin < myDate && myDate < end) {
                    return this.loadData();
                }
            }
            // console.log('已开始播放回调',$event)
        },
        // 当播放器在当前播放位置下载数据时触发
        onPlayerLoadeddata($event) {
            
            // console.log('当播放器在当前播放位置下载数据时触发',$event)
        },
        // 当前播放位置发生变化时触发。
        onPlayerTimeupdate(player) {
            // console.log('当前播放位置发生变化时触发。',$event)
        },
        //媒体的readyState为HAVE_FUTURE_DATA或更高
        onPlayerCanplay(player) {
            
        // console.log('player Canplay!', player)
        },
        //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
        onPlayerCanplaythrough(player) {
            
        // console.log('player Canplaythrough!', player)
        },
        //播放状态改变回调
        playerStateChanged(playerCurrentState) {
            // let mydata = Date.parse(new Date())
            // console.log(mydata)
        //console.log('player current update state', playerCurrentState)
        },
        //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
        playerReadied(player) {
            if(this.isn) {
                if(this.details.LiveStep == 1) {
                    player.currentTime(this.details.PreheatingVideoCurrentSecond)
                }else if(this.details.LiveStep == 2){
                    player.currentTime(this.details.LiveCurrentSecond)
                }
                this.isn = false
            }
            const myPlayer = this.$refs.videoPlayer.player
            myPlayer.play()
            // setTimeout(function(){
            //     $('.vjs-tech')[0].removeAttribute('muted');
            // },100)
        },
        // 赞助商跳转
        linkSponsor(url){
            window.open(url)
        },
    },
    
}
</script>
<style lang="scss">
    .forun-main {
        margin-top: 69px;
        padding-bottom: 60px;
        .forum-header {
            height: 972px;
            background-image: url('~@/assets/activity/forum/content-bg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .content-main {
            width: 1200px;
            margin: 0 auto;
        }
        .main-flex {
            padding-top: 68px;
            display: flex;
            justify-content: space-between;
            min-height: 338px;
            .head-left {
                width: 900px;
                .img-title {
                    display: block;
                    width: 100%;
                    height: auto;
                }
                p {
                    color: #FDCE72;
                    font-size: 26px;
                    text-align: center;
                    line-height: 26px;
                    margin-top: 26px;
                }
            }
            .head-right {
                margin-right: 10px;
                text-align: center;
                .share-bg {
                    background-image: url('~@/assets/activity/forum/forum-share.png');
                    background-repeat: no-repeat;
                    background-size: cover;
                    width: 212px;
                    height: 230px;
                    position: relative;
                    h5 {
                        width: 90px;
                        height: 24px;
                        // position: absolute;
                        // left: 61px;
                        // top: 34px;
                        margin: 34px auto 0;
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                    }
                    h5.subscribe {      //预约有礼
                        background-image: url('~@/assets/activity/forum/yyyl.png');
                    }
                    h5.lottery {
                        background-image: url('~@/assets/activity/forum/jlkj.png');
                    }
                    .n {
                        font-size: 12px;
                        color: #A82703;
                        text-align: center;
                    }
                    .label-box {
                        color: #842600;
                        margin-top: 14px;
                        min-height: 80px;
                        label {
                            display: block;
                            text-align: center;
                            line-height: 22px;
                            font-size: 18px;
                            font-weight: 500;
                            font-weight: 600;
                        }
                    }
                    .label-tips-no {
                        .min-top {
                            margin-top: 4px;
                        }
                        p {
                            font-size: 14px;
                            line-height: 18px;
                            text-align: center;
                        }
                    }
                    .lucky-n {
                        color: #fff;
                        font-size: 14px;
                        text-align: center;
                        line-height: 24px;
                    }
                    .link {
                        cursor: pointer;
                    }
                    .popover-tips {
                        width: 200px;
                        position: absolute;
                        right:-170px;
                        top: -10%;
                        background: #fff;
                        padding: 18px 20px;
                        border-radius: 4px;
                        text-align: left;
                        opacity: 0;
                        transition: opacity .4s;
                    }
                    & .tips-div:hover .popover-tips{
                        opacity: 1;
                    }
                }
                .download-btn {
                    width: 185px;
                    height: 34px;
                    background: #fff;
                    color: #070E44;
                    border-radius: 17px;
                    font-size: 16px;
                    cursor: pointer;
                    margin-top: 5px;
                    &:hover {
                        background: #f75959;
                        color: #fff;
                    }
                }
                
            }
        }
        .video-chat-main {
            height: 540px;
            display: flex;
            justify-content: flex-start;
            margin-top: 30px;
            .video-box {
                width: 930px;
                height: 100%;
                video {
                    display: block;
                    width: 930px;
                    height: 540px;
                    background:#0F0F0F;
                }
                .vjs-custom-skin > .video-js {
                    width: 930px;
                    height: 540px;
                }
                .vjs-fluid {
                    padding-top: 0;
                    width: 930px;
                    height: 540px;
                }
                .video-js .vjs-tech {
                    width: 100% !important;
                    height: 100% !important;
                }
                .vjs-fullscreen-control {
                    position: absolute;
                    right: 0;
                    top: 0;
                }
            }
            .chat-box {
                width: 270px;
                height: 100%;
                background: #2D2D2D;
                padding: 20px 16px;
                position: relative;
                .up-scroll {
                    height: 448px;
                    margin-right: 16px;
                    margin-right: -16px;
                    overflow-x:hidden;
                    overflow-y: scroll;
                
                    .chat-list {
                        overflow: hidden;
                        li {
                            color: #fff;
                            font-size: 16px;
                            line-height: 20px;
                            padding-bottom: 10px;
                            word-break: break-all;
                            img {
                                margin-right: 3px;
                            }
                        }
                    }
                    &::-webkit-scrollbar {
                        width: 4px;
                    }
                    &::-webkit-scrollbar-thumb {
                        border-radius: 4px;
                        background: #0F0F0F;
                    }
                }
                .send-box {
                    width: 236px;
                    height: 32px;
                    margin-top: 20px;
                    border-radius: 16px;
                    background: #0F0F0F;
                    position: absolute;
                    left: 16px;
                    bottom: 20px;
                    display: flex;
                    overflow: hidden;
                    input {
                        width: 168px;
                        background: transparent;
                        color: #fff;
                        font-size: 16px;
                        padding-left: 12px;
                        padding-right: 12px;
                    }
                    button{
                        width: 68px;
                        border: none;
                        background: #666666;
                        cursor: pointer;
                        font-size: 14px;
                        text-align: center;
                        line-height: 32px;
                        &:hover {
                            color: #fff;
                        }
                    }
                }
            }
        }
        .forum-content {
            .column-title {
                padding-top: 80px;
                padding-bottom: 46px;
                text-align: center;
            }
            .subnav-box {
                display: flex;
                justify-content: space-between;
                margin-bottom: 44px;
                button {
                    border-radius: 10px;
                    border: 1px solid #071257;
                    height: 38px;
                    width: 120px;
                    font-size: 16px;
                    color: #071257;
                    line-height: 34px;
                    background: none;
                    cursor: pointer;
                    &.on,
                    &:hover {
                        background: #071257;
                        color: #fff;
                    }
                }
            }
            .container-list {
                box-shadow: 0px 2px 20px 0px rgba(34,23,20,.1);
                border: 1px solid #fff;
                border-radius: 20px;
                min-height: 410px;
                .int-item {
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    padding: 33px 20px;
                    .bbs-list {
                        width: 688px;
                        .bbs-item {
                            overflow: hidden;
                            min-height: 122px;
                            div {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                h3 {
                                    font-size: 22px;
                                    line-height: 22px;
                                    font-weight: bold;
                                    color: #333;
                                }
                                span {
                                    color: #999999;
                                    font-size: 18px;
                                    line-height: 22px;
                                    padding-left: 24px;
                                    background-repeat: no-repeat;
                                    background-position: left center;
                                    // min-width: 50px;
                                    text-align: center;
                                    cursor: pointer;
                                }
                                span.icon-no-praise {
                                    background-image: url('~@/assets/new/icon-no-praise.png');
                                }
                                span.icon-yes-praise {
                                    background-image: url('~@/assets/new/icon-yes-praise.png');
                                }
                            }
                            p {
                                font-size: 16px;
                                color: #999;
                                line-height: 30px;
                                font-weight: 400;
                                margin-top: 10px;
                                max-height: 113px;
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                            }
                        }
                        .bbs-item:last-child {
                            min-height: 92px;
                        }
                    }
                    .share-status {
                        padding-top: 50px;
                        padding-left: 50px;
                    }
                    .item-right {
                        flex: 0 0 436px;
                        min-height: 344px;
                        background: #F9F9F9;
                        border-radius: 20px;
                        padding: 50px 20px;
                        position: relative;
                        p {
                            font-size: 15px;
                            color: #333;
                            font-weight: 400;
                            line-height: 30px;
                            margin-top: -7px;
                            margin-bottom: 16px;
                        }
                        ol {
                            li {
                                padding-left: 24px;
                                font-size: 16px;
                                color: #333;
                                font-weight: bold;
                                line-height: 30px;
                                margin-bottom: 6px;
                                background-repeat: no-repeat;
                                background-position: 0 7px;
                                &.xz {
                                    background-image: url('~@/assets/activity/forum/xz.png');
                                }
                                &.ts {
                                    background-image: url('~@/assets/activity/forum/ts.png');
                                }
                                &.lw {
                                    background-position: 0 6px;
                                    background-image: url('~@/assets/activity/forum/lw.png');
                                }
                            }
                        }
                        button,
                        a {
                            width: 180px;
                            height: 48px;
                            background: #111E6E;
                            border-radius: 24px; 
                            font-size: 16px;
                            color: #fff;
                            font-weight: 400;
                            cursor: pointer;
                            position: absolute;
                            left: 50%;
                            bottom: 50px;
                            margin-left: -90px;
                        }
                        a {
                            text-align: center;
                            line-height: 48px;
                        }
                    }
                }
            }
        }
        .ups-main {
            .ups-list {
                display: flex;
                // justify-content: space-between;
                justify-content: flex-start;
                flex-wrap: wrap;
                li {
                    width: 290px;
                    height: 194px;
                    background: #f9f9f9;
                    border-radius: 10px;
                    overflow: hidden;
                    margin-bottom: 20px;
                    position: relative;
                    cursor: pointer;
                    margin-right: 13px;
                    img{
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                    span {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 34px;
                        text-align: center;
                        background: rgba($color: #000000, $alpha: .6);
                        font-size: 16px;
                        color: #fff;
                        line-height: 34px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap; 
                        padding: 0 20px;            
                    }
                    &:hover {
                        box-shadow: 0px 2px 20px 0px rgba(34,23,20,.2);
                    }
                    &:nth-of-type(4n+0){margin-right: 0;}
                }
                li:last-child {
                    box-shadow: 0px 2px 20px 0px rgba(34,23,20,.1);
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    p {
                        font-size: 22px;
                        color: #333;
                        font-weight: 500;
                        line-height: 22px;
                        margin-bottom: 10px;
                    }
                    button {
                        background: none;
                        color:#071257;
                        font-size: 16px;
                        line-height: 16px;
                        font-weight: bold;
                        padding: 0;
                    }
                }
                &:after {
                    content: "";
                    width: 290px;
                }
            }
            .pagination-list {
                display: flex;
                align-items: center;
                justify-content: center;
                li {
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                    background: #999999;
                    font-size: 0;
                    margin: 0 10px;
                    cursor: pointer;
                    &.on,
                    &:hover {
                        background: #111E6E;
                    }
                }
            }
        }
        .certification-main {
            display: flex;
            justify-content: space-between;
            div.item-one:hover,
            div.item-two:hover,
            div.item-three > div:hover {
                box-shadow: 0px 2px 20px 0px rgba(34,23,20,.1);
            }
            h3 {
                font-size: 22px;
                color: #333;
                font-weight: bold;
            }
            .item-one {
                width: 370px;
                height: 284px;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                background-image: url('~@/assets/activity/forum/min-bg-1.png');
                cursor: pointer;
                border-radius: 10px;
                overflow: hidden;
                caret-color: transparent;
            }
            .item-two {
                width: 260px;
                height: 284px;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                background-image: url('~@/assets/activity/forum/min-bg-2.png');
                cursor: pointer;
                border-radius: 10px;
                overflow: hidden;
                caret-color: transparent;
            }
            .item-three {
                caret-color: transparent;
                .items {
                    width: 255px;
                    height: 132px;
                    display: flex;
                    text-align: center;
                    align-items: center;
                    justify-content: center;
                    background-image: url('~@/assets/activity/forum/min-bg-3.png');
                    cursor: pointer;
                    border-radius: 10px;
                    overflow: hidden;
                    p {
                        font-size: 16px;
                        color: #333;
                        line-height: 20px;
                        margin-top: 10px;
                    }
                }
                .items:first-child {
                    margin-bottom: 20px;
                }
            }
        }
        .friendlink-list {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .items {
                width: 316px;
                text-align: center;
                margin-bottom: 10px;
                .logo-tips {
                    width: 100%;
                    height: 192px;
                    border: 1px solid #e9e9e9;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                    overflow: hidden;
                    img {
                        display: block;
                        max-width: 100%;
                        height: 100%;
                    }
                    p {
                        position: absolute;
                        left: 0;
                        top: 0;
                        padding: 20px 14px 20px 20px;
                        color: #333;
                        font-size: 14px;
                        line-height: 20px;
                        width: 100%;
                        height: 100%;
                        background: rgba($color: #fff, $alpha: 1);
                        text-align: left;
                        opacity: 0;
                        transition: opacity .4s;
                        overflow-x: hidden;
                        overflow-y: scroll;
                        &::-webkit-scrollbar {
                            width: 4px;
                        }
                        &::-webkit-scrollbar-thumb {
                            border-radius: 4px;
                            background: #e9e9e9;
                        }
                    }
                    &:hover p {
                        opacity: 1;
                    }
                }
                h3 {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding: 0 20px;
                    font-size: 20px;
                    color: #333;
                    font-weight: 500;
                    line-height: 60px;
                }
            }
            li:last-child {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                width: 316px;
                height: 192px;
                border: 1px solid #e9e9e9;
                border-radius: 4px;
                p {
                    font-size: 22px;
                    color: #333;
                    font-weight: 500;
                    line-height: 22px;
                    margin-bottom: 10px;
                }
                button {
                    background: none;
                    color:#071257;
                    font-size: 16px;
                    line-height: 16px;
                    font-weight: bold;
                    padding: 0;
                }
            }
            li.items:hover div,
            li:last-child:hover {
                box-shadow: 0px 2px 20px 0px rgba(34,23,20,.1);
            }
            &:after {
                content: "";
                width: 316px;
            }
        }
    }
.collect-dialog {
    .form-collect{
        &.form {
            width: 500px;
            margin: 20px auto 0;
            padding-bottom: 0px;
        }
        .form-item {
            position: relative;
            margin-bottom: 20px;
            overflow: hidden;
        }
        .input-box {
            min-height: 40px;
            position: relative;
            overflow: hidden;
            width: 378px;
            float: right;
        }
        .icon-location{
            position: absolute;
            right: 4px;
            top: 10px;
            font-size: 20px;
            color: #f75959;
        }
        .form-item .label {
            font-size: 14px;
            line-height: 24px;
            font-weight: bold;
            padding: 8px 0;
            color: #333;
            width: 120px;
            float: left;
            padding-right: 8px;
            text-align: right;
        }
        .form-item .input {
            width: 100%;
            height: 40px;
            border: 1px solid #e3e3e3;
            font-size: 14px;
            color: #333;
            padding: 8px 10px;
            line-height: 22px;
            &.address-input{
                padding-right: 30px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .btn-primary{
            display: block;
            width: 100px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            color: #fff;
            background-color: #f75959;
            border-radius: 4px;
            text-align: center;
            margin: 30px auto 0;
            cursor: pointer;
        }
    }
    .successTips {
        padding: 30px 0;
        text-align: center;
        font-size: 22px;
        color: #333;
        line-height: 30px;
    }
}
.share-dialog {
    .dialog-container {
        overflow: inherit;
    }
    .share-box {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 60px 0;
        .share-item {
            position: relative;
            .logo-box {
                text-align: center;
                width: 186px;
                color: #333;
                img {
                    margin: 0 auto 16px;
                    display: block;
                    width: 48px;
                    height: 40px;
                }
                p {
                    font-size: 22px;
                    // color: #333;
                    line-height: 22px;
                }
            }
            .hover-er {
                position: absolute;
                bottom: -184px;
                left: 0;
                width: 186px;
                height: 165px;
                background: #f1f1f1;
                border-radius: 10px;
                opacity: 0;
                transition: opacity .4s;
                .car {
                    position: absolute;
                    left: 50%;
                    top: -27px;
                    font-size: 40px;
                    transform: translate(-50%, 0);
                    color: #f1f1f1;
                }
                img {
                    display: block;
                    width: 116px;
                    height: 116px;
                    background: #999;
                    margin: 0 auto;
                    margin-top: 8px;
                }
                p {
                    font-size: 16px;
                    color: #333;
                    text-align: center;
                    line-height: 40px;
                }
            }
            &:hover .logo-box {
                color: #f75959;
            }
            &:hover .hover-er {
                opacity: 1;
            }
        }
    }
}
.screen-video {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    video {
        width: 100%;
        height: 100%;
        background: #0F0F0F;
    }
    video::-webkit-media-controls-fullscreen-button {
        display: none;
    }
}
.close-x {
    font-size: 40px;
    position: absolute;
    right: 2%;
    top: 30px;
    color: #fff;
    cursor: pointer;
    z-index: 10;
    caret-color: transparent;
    &:hover {
        color: #f75959;
    }
}
.ecode-box {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: .6);
    display: flex;
    justify-content: center;
    align-items: center;
    >div {
        width: 300px;
        height: 300px;
        border-radius: 20px;
        overflow: hidden;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        img {
            display: block;
            max-width: 100%;
            height: auto;
        }
    }
}
</style>